var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.5a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0-12a.75.75 0 0 0-.75.75v3.5c0 .416.334.75.75.75s.75-.334.75-.75v-3.5A.75.75 0 0 0 10 6m1 7a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
  })));
};
export default SvgWarningCircle;